import { Typography, Container } from '@mui/material';

const MesDocuments = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
                Mes documents
            </Typography>
            <Typography>
                Vos documents personnels. Ajoutez ici la logique pour afficher ou télécharger.
            </Typography>
        </Container>
    );
};

export default MesDocuments;